import styles from "./index.module.css";
import { useEffect, useRef } from "react";
import BuyCard from "../../buyCard";
import VideoAlert from "../../../video-alert";
import PreAndNext from "../../preAndNext";
import Cast from "../../cast";
import LazyLoad from "react-lazyload";
const ManAndFishDetail = ({
  isMobile,
  handleNextIndex,
  handleLastIndex,
  playVideo,
  pauseVideo,
  movieData,
}) => {
  useEffect(() => {
    new VideoAlert(
      {
        havePathElement: `.${styles.btsPlayButton}`,
        openAlert: pauseVideo,
      },
      []
    );
  });

  return (
    <div className={styles.ctn}>
      <div className={styles.movieInfo}>
        <div className={styles.movieNameBox}>
          <img
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-3-1.jpg"
            alt=""
            className={styles.movieName}
          />
          <img
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-3-2.jpg"
            alt=""
            className={styles.btsPlayButton}
            data-cursor-size="80px"
            data-video-src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-bts-03.mp4"
          />
        </div>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-3-3${
            isMobile ? "-m" : ""
          }.jpg`}
          alt=""
          className={styles.author}
        />
      </div>
      <div>
        <LazyLoad offset={300}>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-3-4.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-3-4-cover.jpg"
            className={styles.abMedia1}
          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-3-5${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>

      <div>
        <LazyLoad offset={300}>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-3-6.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-3-6-cover.jpg"
            className={styles.abMedia2}
          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-3-7${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>

      <div>
        <LazyLoad offset={300}>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-3-8.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-3-8-cover.jpg"
            className={styles.abMedia3}
          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-3-9${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>

      <div>
        <LazyLoad offset={300}>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-3-10.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-3-10-cover.jpg"
            className={styles.abMedia4}
          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-3-11${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>

      <div>
        <LazyLoad offset={300} className={styles.abMedia5}>
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-3-12.mp4"
            poster="https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-3-12-cover.jpg"
            
          ></video>
        </LazyLoad>

        <img
          src={`https://bucket.zhiyun-tech.com/detail/sm5sfilm2022/sm5sfilm2022-3-13${
            isMobile ? "-m" : ""
          }.png`}
          alt=""
        />
      </div>
      <Cast
        movieName={movieData.name}
        data={[
          {
            post: "DIRECTOR&WRITER",
            name: "REANGSEI PHOS",
          },
          {
            post: "STARRING",
            name: "MICHIAEL SUI, CHRISTY KIM, SUKHMAN BOPARAI, NATALIE PANG, MATTHEW PUZHITSKY",
          },
          {
            post: "BACKGROUND",
            name: "LUCKY DO, TRISTAN HAY, LILIANE ZHEN, JOSEPH ALAFIF, ETHAN GARFIELD, LUCY HUGHES, ANNA SAKHATSKIDH",
          },
          {
            post: "PRODUCER",
            name: "MAC DOWNEY",
          },
          {
            post: "DIRECTOR OF PHOTOGRAPHY",
            name: "ASH TAILOR-JONES",
          },
          {
            post: "ASSISTANT DIRECTOR",
            name: "MAC DOWNEY",
          },
          {
            post: "ART DIRECTOR",
            name: "ALEX HUBBS",
          },
          {
            post: "SOUND RECORDIST",
            name: "LAUREN NEESON",
          },
          {
            post: "MAKE-UP&HAIR ARTIST",
            name: "TONGFEI XU",
          },
          {
            post: "STYLIST",
            name: "ALEX HUBBS",
          },
          {
            post: "SOUND DESIGNER",
            name: "ALEX BOLOGNA",
          },
          {
            post: "COMPOSER",
            name: "AHN DAYOUNG",
          },
          {
            post: "COLORIST",
            name: "ASH TAILOR-JONES",
          },
          {
            post: "EDITOR",
            name: "YASHAR NIA",
          },
          {
            post: "PRODUCTION ASSISTANT",
            name: "JUSTIN TAN, DESTINY NOSA, RACHEL KUANG",
          },
          {
            post: "BTS",
            name: "JOSH CARLAN, DEANDRE BLAIR-WASHINGTON, DANIEL YOUSSEFI",
          },
        ]}
      />
    </div>
  );
};

export default ManAndFishDetail;
